import { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Stats from './components/Stats';
import BeforeAfterSimple from './components/BeforeAfterSimple';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import FloatingCallButton from './components/FloatingCallButton';
import WhatsAppButton from './components/WhatsAppButton';
import BookingModal from './components/BookingModal';
import { BookingProvider, useBooking } from './context/BookingContext';

function AppContent() {
  const { isBookingModalOpen, closeBookingModal } = useBooking();
  
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <Stats />
        <BeforeAfterSimple />
        <About />
        <Testimonials />
        <Contact />
      </main>
      
      {/* Floating Action Buttons */}
      <FloatingCallButton />
      <WhatsAppButton />
      
      {/* Global Booking Modal */}
      <BookingModal isOpen={isBookingModalOpen} onClose={closeBookingModal} />
    </div>
  );
}

function App() {
  return (
    <BookingProvider>
      <AppContent />
    </BookingProvider>
  );
}

export default App;
